/* LG Wishlist : favoris enregistrés dans le navigateur sur cet appareil.
   Stockage local, sans synchronisation avec un compte client. */
(() => {
  'use strict';
  if (window.LGWishlistCore) return;
  const KEY = 'lg-wishlist-lab-items-v1';
  const MAX = 40;
  const HANDLE = /^[a-z0-9][a-z0-9-]*$/;
  const ID = /^\d{1,20}$/;
  const eventName = 'lg:wishlist-lab:changed';

  function valid(item) {
    return item && typeof item.handle === 'string' && HANDLE.test(item.handle) &&
      ID.test(String(item.variant_id || ''));
  }
  function productId(value) {
    const id=String(value || '');
    return ID.test(id) ? id : null;
  }
  function read() {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      const known = new Set();
      return raw.filter(item => {
        if (!valid(item)) return false;
        const k = item.handle + '|' + String(item.variant_id);
        if (known.has(k)) return false;
        known.add(k);
        return true;
      }).slice(0, MAX);
    } catch(error) { return []; }
  }
  function write(items) {
    try {
      const unique = [], known = new Set();
      for (const item of items) {
        if (!valid(item)) continue;
        const k = item.handle + '|' + String(item.variant_id);
        if (known.has(k)) continue;
        known.add(k);
        const normalized={handle:item.handle,variant_id:String(item.variant_id),
          added_at:item.added_at || new Date().toISOString()};
        const id=productId(item.product_id);
        if(id) normalized.product_id=id;
        unique.push(normalized);
        if (unique.length >= MAX) break;
      }
      localStorage.setItem(KEY, JSON.stringify(unique));
      window.dispatchEvent(new CustomEvent(eventName,{detail:{count:unique.length}}));
      return true;
    } catch(error) { return false; }
  }
  function has(handle, variantId) {
    return read().some(item => item.handle === handle && String(item.variant_id) === String(variantId));
  }
  function toggle(handle, variantId, productShopifyId) {
    if (!HANDLE.test(String(handle)) || !ID.test(String(variantId))) return {ok:false,reason:'invalid'};
    const items=read(), existing=items.findIndex(x=>x.handle===handle && String(x.variant_id)===String(variantId));
    if (existing >= 0) {
      items.splice(existing,1);
      return {ok:write(items),added:false};
    }
    if (items.length >= MAX) return {ok:false,reason:'limit'};
    const next={handle,variant_id:String(variantId),added_at:new Date().toISOString()};
    const pid=productId(productShopifyId);
    if(pid) next.product_id=pid;
    items.unshift(next);
    return {ok:write(items),added:true};
  }
  function currentVariant(button) {
    const id=button.dataset.lgWishlistForm;
    if (id) {
      const form=document.getElementById(id);
      const selected=form?.querySelector('input[name="id"]:not([disabled]),select[name="id"]:not([disabled])');
      if(selected && ID.test(String(selected.value))) return String(selected.value);
    }
    return button.dataset.lgWishlistVariant;
  }
  function synchronizeButtons() {
    const stored=read();
    let enriched=false;
    document.querySelectorAll('[data-lg-wishlist-heart]').forEach(btn => {
      const handle=btn.dataset.lgWishlistHandle, variant=currentVariant(btn);
      if (!HANDLE.test(handle || '') || !ID.test(String(variant || ''))) return;
      const pid=productId(btn.dataset.lgWishlistProductId);
      if(pid) {
        for(const item of stored) {
          if(item.handle===handle && !item.product_id) {
            item.product_id=pid;
            enriched=true;
          }
        }
      }
      const selected=has(handle,variant);
      const label=selected
        ? (btn.dataset.lgWishlistLabelRemove || 'Retirer de ma sélection')
        : (btn.dataset.lgWishlistLabelAdd || 'Ajouter à ma sélection');
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      btn.setAttribute('aria-label', label);
      btn.title=label;
      const span=btn.querySelector('[data-lg-wishlist-heart-label]');
      if(span && span.textContent !== label) span.textContent=label;
    });
    if(enriched) write(stored);
    const count=stored.length;
    document.querySelectorAll('[data-lg-wishlist-view-link]').forEach(link => {
      const badge=link.querySelector('[data-lg-wishlist-count]');
      if(badge) {
        if(badge.textContent !== String(count)) badge.textContent=String(count);
        badge.hidden=(count===0);
      }
      const viewLabel=link.dataset.lgWishlistViewLabel || 'Voir ma sélection';
      const countName=count===1
        ? (link.dataset.lgWishlistCountOne || 'produit')
        : (link.dataset.lgWishlistCountMany || 'produits');
      const accessible=count ? viewLabel + ', ' + count + ' ' + countName : viewLabel;
      if(link.getAttribute('aria-label')!==accessible)link.setAttribute('aria-label',accessible);
    });
  }
  const configuredMessages=(() => {
    try {
      const source=document.getElementById('lg-wishlist-toast-labels');
      return source ? JSON.parse(source.textContent || '{}') : {};
    } catch(error) { return {}; }
  })();
  function copy(type,fallback) {
    const value=configuredMessages[type];
    return typeof value==='string' && value.trim() ? value : fallback;
  }
  let toastTimer;
  function notify(message) {
    let node=document.getElementById('lg-wishlist-lab-notice');
    if (!node) {
      node=document.createElement('div');
      node.id='lg-wishlist-lab-notice';
      node.className='lg-wishlist-lab-notice';
      node.setAttribute('role','status');
      node.setAttribute('aria-live','polite');
      document.body.append(node);
    }
    node.textContent=message;
    node.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer=window.setTimeout(()=>node.classList.remove('is-visible'),2600);
  }
  let pending=false;
  function scheduleSync() {
    if (pending) return;
    pending=true;
    requestAnimationFrame(() => { pending=false; synchronizeButtons(); });
  }
  document.addEventListener('click', event => {
    const btn=event.target.closest('button[data-lg-wishlist-heart]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const result=toggle(btn.dataset.lgWishlistHandle,currentVariant(btn),btn.dataset.lgWishlistProductId);
    if (!result.ok) {
      const message=result.reason==='limit'
        ? copy('limit','La sélection est limitée à '+MAX+' produits.')
        : copy('error','Impossible d’enregistrer ce favori sur cet appareil.');
      window.dispatchEvent(new CustomEvent('lg:wishlist-lab:error',{detail:{message}}));
      notify(message);
    } else {
      notify(result.added
        ? copy('added','Ajouté à ma sélection')
        : copy('removed','Retiré de ma sélection'));
    }
    scheduleSync();
  });
  document.addEventListener('change', event => {
    if(event.target.closest('product-rerender') || event.target.closest('product-card')) scheduleSync();
  });
  window.addEventListener('storage', event => {
    if(event.key === KEY || event.key === null) {
      scheduleSync();
      window.dispatchEvent(new CustomEvent(eventName,{detail:{count:read().length,external:true}}));
    }
  });
  window.addEventListener(eventName,scheduleSync);
  document.addEventListener('shopify:section:load',scheduleSync);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scheduleSync,{once:true});
  else scheduleSync();
  let observerTarget=null;
  const observer=new MutationObserver(records=>{
    for(const record of records) {
      if(record.addedNodes.length || record.removedNodes.length) { scheduleSync(); break; }
    }
  });
  function observe() {
    // Les fenêtres d'achat rapide peuvent être déplacées hors du <main>.
    const target=document.body;
    if(target && target!==observerTarget) {
      observer.disconnect();
      observerTarget=target;
      observer.observe(target,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observe,{once:true});
  else observe();
  window.LGWishlistCore={key:KEY,read,write,has,toggle,MAX};
  window.dispatchEvent(new Event('lg:wishlist-lab:ready'));
})();